export default {
  AD_CLICKED: 'ad_click',
  AD_FINISH: 'finish_ad',
  AD_START: 'start_ad',
  ERROR_WHILE_PLAYING: 'error_while_playing',
  LOGIN: 'login',
  LOGOUT: 'logout',
  PAGE_VIEW: 'pageview',
  SEARCH: 'search',
  SHOW_SIGN_UP_FORM: 'show_sign_up_form',
  START_PLAYING: 'start_playing',
  PAUSE_PLAYING: 'pause_playing',
  STOP_PLAYING: 'stop_playing',
  VIDEO_PROGRESS: 'video_progress',
};
